import React from "react";

import { NavLink, NavLinkProps } from "react-bootstrap";

import classNames from "classnames";
import { Link, LinkProps } from "react-router-dom";
import { ReactSVG } from "react-svg";

import styles from "./IconNavLink.module.scss";

export const IconNavLink = ({
  isDisable,
  isActive,
  src,
  text,
  ...rest
}: NavLinkProps & LinkProps & { src: string; text?: string; isActive?: boolean; isDisable?: boolean }) => {
  return (
    <NavLink
      {...rest}
      className={classNames(styles["icon-navlink"], "d-flex", {
        [styles["active"]]: isActive,
        [styles["disabled"]]: isDisable,
      })}
      as={Link}
    >
      <ReactSVG src={src} />
      <div className="b3">{text ?? <></>}</div>
    </NavLink>
  );
};
